import { getUserDetails, makeGetCall, makePostCall } from './helper';

const STORAGE_KEY = 'ohif-study-browser-position';
const DEFAULT_POSITION = 'left';

const getUsername = () => {
  const u = getUserDetails();
  return u?.username || u?.user_name || null;
};

/**
 * Hydrate localStorage from backend on app load.
 * Safe to call when not logged in — just no-ops.
 */
export const preloadPanelPreference = async () => {
  const username = getUsername();
  if (!username) return null;

  try {
    const resp = await makeGetCall(
      `/get-all-user-preferences?username=${encodeURIComponent(username)}`
    );
    const position = resp?.data?.data?.panel_position?.studyBrowser;
    if (position) {
      localStorage.setItem(STORAGE_KEY, position);
      return position;
    }
  } catch (e) {
    console.warn('panelPreferenceApi: preload failed, using local/default config', e);
  }
  return null;
};

/**
 * Persist panel position to backend AND mirror into localStorage.
 */
export const persistPanelPreference = async position => {
  const username = getUsername();

  localStorage.setItem(STORAGE_KEY, position);

  if (!username) return position;

  try {
    await makePostCall('/save-user-preference', {
      username,
      type: 'panel_position',
      value: { studyBrowser: position },
    });
  } catch (e) {
    console.error('panelPreferenceApi: failed to persist panel preference', e);
  }
  return position;
};
